import type { AppRouteModule } from '@/router/types';
import { t } from '@/hooks/web/useI18n';

const fullProcessTraceRoute: Array<AppRouteModule> = [
  {
    path: '/fullProcessTrace',
    name: 'fullProcessTrace',
    component: () =>
      import(/* webpackChunkName: "fullProcessTrace" */ '@/views/fullProcessTrace/index.vue'),
    meta: {
      title: t('联查'),
      ignoreAuth: true,
      hideMenu: true,
      hideBreadcrumb: true,
      // 与业务页同走 KeepAlive 分支，避免进入联查时拆掉全局 KeepAlive 导致其他页签重挂载
      keepAlive: true,
    },
  },
];

export default fullProcessTraceRoute;
